import { useCallback, useState, type MouseEvent } from 'react';

export const useMenuAnchor = <T extends HTMLElement = HTMLElement>() => {
  const [anchorEl, setAnchorEl] = useState<T | null>(null);

  const open = useCallback((event: MouseEvent<T>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return { anchorEl, isOpen: Boolean(anchorEl), open, close };
};
